import React from 'react'
import Link from '../../PageComponents/Link'
import BackgroundImage from '../../wp-adons/BackgroundImage'
import { setMargin, setPadding } from '../../utilities'

export default function AboutUserSection ({
  pageName,
  title,
  body,
  button,
  background_image,
  margin_selection,
  padding_selection
}) {
  const pageStyles = {
    ...(setMargin(margin_selection) && { margin: setMargin(margin_selection) }),
    ...(setPadding(padding_selection) && {
      padding: setPadding(padding_selection)
    })
  }
  return (
    <div
      style={{ ...pageStyles }}
      className='bg-white flex w-full items-center justify-center relative'
      id={pageName}
    >
      <div className='relative z-10 bg-white max-w-2xl mt-8'>
        <h1 className='intro-text'>{title}</h1>
        <p
          className='font-text_readable text-color_readable text-lg leading-2 px-4 lg:px-0 mt-4 lg:mt-0'
          dangerouslySetInnerHTML={{ __html: body }}
        />

        {button && (
          <div className='flex lg:inline-flex px-6 lg:px-0 mt-12'>
            <Link
              className='font-medium cursor-pointer uppercase btn btn_white text-center py-3 btn_sm w-full px-8'
              url={button?.url}
            >
              {button?.title}
            </Link>
          </div>
        )}
      </div>
      {background_image && (
        <BackgroundImage background_image={background_image} />
      )}
    </div>
  )
}
